import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "b8a699af-4fc0-4904-bfa9-5dd1c10ccc6f",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-2-item-1.svg` },
  },
  {
    id: "4ba74550-522d-4ea4-be8f-03d18818a1bf",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-2-item-2.svg` },
  },
  {
    id: "9b927849-c848-42ab-9d1b-a04643dfc698",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-2-item-3.svg` },
  },
  {
    id: "c3b0011d-7bb2-46ac-b881-204b40bc4a67",
    options: { image: `${config.ASSETS_URL}/03/02/task/task-2-item-4.svg` },
  },
];

export const task: Task = {
  id: "d2f3bd04-7e86-4791-95bd-2741db954e83",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
    imageHeight: 170,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4ba74550-522d-4ea4-be8f-03d18818a1bf"],
};
